import { render, staticRenderFns } from "./ChangePage.vue?vue&type=template&id=091cb850&scoped=true&"
import script from "./ChangePage.vue?vue&type=script&lang=js&"
export * from "./ChangePage.vue?vue&type=script&lang=js&"
import style0 from "./ChangePage.vue?vue&type=style&index=0&id=091cb850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091cb850",
  null
  
)

export default component.exports